import module from './module.js'
// Components
import './components/component.js'
// LNF
import './components/costoventa/component.js'
import './components/costoventa/lista/component.js'
import './components/launcher/component.js'
import './components/provisioncompras/component.js'
import './components/provisioncompras/lista/component.js'
import './components/provisioncomprasbo/component.js'
import './components/provisioncomprasbo/lista/component.js'
import './components/provisioncompraspagos/component.js'
import './components/provisioncompraspagos/lista/component.js'
import './components/provisioningresos/component.js'
import './components/provisioningresos/lista/component.js'
import './components/provisionnominasconpagossucursales/component.js'
import './components/provisionnominasconpagossucursales/lista/component.js'
import './components/cobranza/component.js'
import './components/cobranza/lista/component.js'
// Algodoneros
import './components/costoventaag/component.js'
import './components/costoventaag/lista/component.js'
import './components/provisioncomprasag/component.js'
import './components/provisioncomprasag/lista/component.js'
import './components/provisioncomprasboag/component.js'
import './components/provisioncomprasboag/lista/component.js'
import './components/provisioningresosag/component.js'
import './components/provisioningresosag/lista/component.js'
import './components/traspasosag/component.js'
import './components/traspasosag/lista/component.js'
import './components/algodoneros/ingresos/component.js'
import './components/algodoneros/ingresos/lista/component.js'
import './components/algodoneros/ingresos/lista/movimientos/component.js'
import './components/algodoneros/ingresos/lista/movimientos/facturas/component.js'
import './components/algodoneros/ingresos/lista/vinculacion/component.js'
import './components/algodoneros/ingresos/lista/vinculacion/seleccionar/component.js'
import './components/algodoneros/poliza-ingresos/component.js'
import './components/algodoneros/poliza-ingresos/lista/component.js'
import './components/algodoneros/pagos-gastos/component.js'
import './components/algodoneros/pagos-gastos/lista/component.js'
import './components/algodoneros/pagos-compras/component.js'
import './components/algodoneros/pagos-compras/lista/component.js'

// Services
import './services/Catalogos/Proyectos.js'
import './services/Catalogos/Proyectos/Nominas.js'
// LNF
import './services/PolizasExternasPermisos'
import './services/PolizasExternasCatalogosAlmacenes.js'
import './services/PolizasExternasCostosventa.js'
import './services/PolizasExternasProvisionCompras.js'
import './services/PolizasExternasProvisionComprasBo.js'
import './services/PolizasExternasProvisionComprasPagos.js'
import './services/PolizasExternasProvisionComprasPagos/MovimientosBancos.js'
import './services/PolizasExternasProvisionIngresos.js'
import './services/PolizasExternasProvisionnominasconpagossucursales.js'
import './services/PolizasExternasCobranza.js'
// Algodoneros
import './services/PolizasExternasCostosventaAg.js'
import './services/PolizasExternasProvisionComprasAg.js'
import './services/PolizasExternasProvisionComprasBoAg.js'
import './services/PolizasExternasProvisionIngresosAg.js'
import './services/PolizasExternasTraspasosAg.js'
import './services/Algodoneros/Ingresos.js'
import './services/Algodoneros/PolizaIngreso.js'
import './services/Algodoneros/Facturas.js'
import './services/Algodoneros/PagosGastos.js'
import './services/Algodoneros/PagosCompras.js'
// Routes
import './routes/polizasexternas.js'
// LNF
import './routes/polizasexternas-costoventa.js'
import './routes/polizasexternas-provisioncompras.js'
import './routes/polizasexternas-provisioncomprasbo.js'
import './routes/polizasexternas-provisioncompraspagos.js'
import './routes/polizasexternas-provisioningresos.js'
import './routes/polizasexternas-provisionnominasconpagossucurales.js'
import './routes/polizasexternas-cobranza.js'
// Algodoneros
import './routes/polizasexternas-costoventaag.js'
import './routes/polizasexternas-provisioncomprasag.js'
import './routes/polizasexternas-provisioncomprasboag.js'
import './routes/polizasexternas-provisioningresosag.js'
import './routes/polizasexternas-traspasosag.js'
import './routes/polizasexternas-algodoneros-vinculacion-ingresos.js'
import './routes/polizasexternas-algodoneros-ingresos.js'
import './routes/polizasexternas-algodoneros-pagos-gastos.js'
import './routes/polizasexternas-algodoneros-pagos-compras.js'

export default module.name



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/index.js